<template>
  <div class="flow-approval-handle">

    <!-- 分步操作（需要填写表单时） -->
    <template v-if="needApprovalForm">
      <el-steps :active="step" finish-status="success" align-center class="handle-steps">
        <el-step title="填写表单"></el-step>
        <el-step title="提交处理"></el-step>
      </el-steps>

      <keep-alive>
        <!-- 步骤一：填写表单 -->
        <div v-if="step === 0" key="step0" class="handle-step-content">
          <form-create v-model="approvalFApi"
                       :rule="formRule"
                       :option="formOption" />
        </div>

        <!-- 步骤二：提交处理 -->
        <div v-else key="step1" class="handle-step-content">
          <FlowApprovalForm ref="handleForm" comment-placeholder="请输入处理意见（选填）">
            <template v-if="needSign" slot="prepend">
              <el-form-item label="签名画板">
                <div class="sign-main-wrap">
                  <div class="sign-body">
                    <CommonSign ref="handleSign"
                                bg-color="#ffffff"
                                :is-clear-bg-color="false"
                                :line-width="6"
                                :width="540"
                                :height="180"
                                :qrcode-mode="showQrcode" />
                  </div>
                  <div class="sign-action">
                    <div class="action-left">
                      <el-radio-group v-model="showQrcode" size="mini">
                        <el-radio-button :label="true">
                          <i class="el-icon-mobile"></i><span>扫码签名</span>
                        </el-radio-button>
                        <el-radio-button :label="false">
                          <i class="el-icon-mouse"></i><span>手写签名</span>
                        </el-radio-button>
                      </el-radio-group>
                    </div>
                    <div class="action-right">
                      <el-button size="mini" type="warning" plain @click="clearSign">重新签名</el-button>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </template>
          </FlowApprovalForm>
        </div>
      </keep-alive>
    </template>

    <!-- 无表单：直接显示处理意见 + 签名 -->
    <template v-else>
      <FlowApprovalForm ref="handleForm" comment-placeholder="请输入处理意见（选填）">
        <template v-if="needSign" slot="prepend">
          <el-form-item label="签名画板">
            <div class="sign-main-wrap">
              <div class="sign-body">
                <CommonSign ref="handleSign"
                            bg-color="#ffffff"
                            :is-clear-bg-color="false"
                            :line-width="6"
                            :width="440"
                            :height="180"
                            :qrcode-mode="showQrcode" />
              </div>
              <div class="sign-action">
                <div class="action-left">
                  <el-radio-group v-model="showQrcode" size="mini">
                    <el-radio-button :label="true">
                      <i class="el-icon-mobile"></i><span>扫码签名</span>
                    </el-radio-button>
                    <el-radio-button :label="false">
                      <i class="el-icon-mouse"></i><span>手写签名</span>
                    </el-radio-button>
                  </el-radio-group>
                </div>
                <div class="action-right">
                  <el-button size="mini" type="warning" plain @click="clearSign">重新签名</el-button>
                </div>
              </div>
            </div>
          </el-form-item>
        </template>
      </FlowApprovalForm>
    </template>

    <!-- 底部按钮 -->
    <div class="handle-footer">
      <!-- 无表单：取消 + 确定操作 -->
      <template v-if="!needApprovalForm">
        <el-button size="small" @click="$emit('cancel')">取消</el-button>
        <el-button type="success" size="small" :loading="submitting" @click="handleSubmit">确定{{ handleAction }}</el-button>
      </template>
      <!-- 有表单第一步：取消 + 下一步 -->
      <template v-else-if="isFirstStep">
        <el-button size="small" @click="$emit('cancel')">取消</el-button>
        <el-button type="primary" size="small" @click="handleNextStep">下一步</el-button>
      </template>
      <!-- 有表单第二步：上一步 + 确定操作 -->
      <template v-else>
        <el-button size="small" @click="handlePrevStep">上一步</el-button>
        <el-button type="success" size="small" :loading="submitting" @click="handleSubmit">确定{{ handleAction }}</el-button>
      </template>
    </div>

  </div>
</template>

<script>
import FlowApprovalForm from '../../../../../elements/flow/approval/FlowApprovalForm'
import CommonSign from '../../../../../common/CommonSign'

export default {
  name: 'FlowApprovalHandle',
  components: { FlowApprovalForm, CommonSign },
  props: {
    handleType: {
      type: String,
      validator (val) {
        return ['approval', 'transact', 'resolve'].includes(val)
      }
    },
    approvalInfo: {
      type: Object,
      default: () => ({})
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      step: 0,
      approvalFApi: {},
      approvalFormData: {},
      showQrcode: true
    }
  },
  computed: {
    needApprovalForm () {
      const formJson = this.approvalInfo && this.approvalInfo.formJson
      if (!formJson) return false
      try {
        const parsed = JSON.parse(formJson)
        return parsed.rule && parsed.rule.length > 0
      } catch (e) {
        return false
      }
    },
    needSign () {
      if (this.handleType === 'resolve') {
        return false
      }
      return this.approvalInfo && this.approvalInfo.useSign
    },
    formOpts () {
      if (!this.needApprovalForm) return {}
      try {
        return JSON.parse(this.approvalInfo.formJson)
      } catch (e) {
        return {}
      }
    },
    formRule () {
      return this.formOpts.rule || []
    },
    formOption () {
      const option = this.formOpts.option || {}
      return {
        ...option,
        submitBtn: false,
        resetBtn: false,
        form: { ...(option.form || {}) }
      }
    },
    isFirstStep () {
      return this.needApprovalForm && this.step === 0
    },
    handleAction () {
      switch (this.handleType) {
        case 'approval':
          return '同意'
        case 'transact':
          return '办理'
        case 'resolve':
        default:
          return '处理'
      }
    }
  },
  watch: {
    approvalFApi: {
      handler (fApi) {
        if (fApi && fApi.setValue && this.approvalInfo && this.approvalInfo.formData) {
          this.$nextTick(() => {
            fApi.setValue(this.approvalInfo.formData)
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    reset () {
      this.step = 0
      this.approvalFormData = {}
      this.showQrcode = true
    },
    clearSign () {
      if (this.$refs.handleSign) {
        this.$refs.handleSign.reset()
      }
    },
    handleNextStep () {
      if (!this.approvalFApi || !this.approvalFApi.validate) {
        this.step = 1
        return
      }
      this.approvalFApi.validate().then(() => {
        this.approvalFormData = this.approvalFApi.formData()
        this.step = 1
      }).catch(() => {
        this.$message.warning('请完成表单填写')
      })
    },
    handlePrevStep () {
      this.step = 0
    },
    handleSubmit () {
      this.$refs.handleForm.validate().then(formData => {
        const data = { ...formData }
        if (this.needApprovalForm) {
          data.approvalFormData = this.approvalFormData
        }
        if (this.needSign) {
          const signRef = this.$refs.handleSign
          if (!signRef) {
            this.$emit('submit', data)
            return
          }
          signRef.generate().then(signInfo => {
            if (!signInfo) {
              this.$message.warning('请完成签名')
              return
            }
            data.signInfo = signInfo
            this.$emit('submit', data)
          }).catch(err => {
            this.$message.warning(err.message)
          })
        } else {
          this.$emit('submit', data)
        }
      }).catch(err => {
        this.$message.warning(err && err.message)
      })
    }
  }
}
</script>

<style lang="scss">
.flow-approval-handle {
  .handle-steps {
    margin-bottom: 20px;
    padding: 15px 20px 5px;
    background: linear-gradient(135deg, #f0f4ff 0%, #f5f7fa 100%);
    border-radius: 8px;
    border: 1px solid #e4e9f5;

    .el-step__title {
      font-size: 12px;
      &.is-wait { color: #c0c4cc; }
      &.is-process { font-weight: 600; color: #409eff; }
      &.is-finish { color: #67c23a; }
    }

    .el-step__icon {
      width: 26px;
      height: 26px;
      font-size: 12px;
      font-weight: 700;
    }

    .el-step__icon.is-text {
      border-width: 2px;
    }

    .el-step__head.is-process .el-step__icon {
      background-color: #409eff;
      border-color: #409eff;
      color: #fff;
    }

    .el-step__head.is-finish .el-step__icon {
      border-color: #67c23a;
      color: #67c23a;
    }

    .el-step__head.is-wait .el-step__icon {
      border-color: #dcdfe6;
      color: #c0c4cc;
      background: #fff;
    }

    .el-step__line {
      top: 12px;
      height: 2px;
      background-color: #e4e9f5;
    }

    .el-step__head.is-finish .el-step__line-inner {
      border-width: 2px;
      border-color: #67c23a;
    }
  }

  .handle-step-content {
    min-height: 120px;
  }

  .handle-footer {
    margin-top: 16px;
    padding-top: 12px;
    border-top: 1px solid #ebeef5;
    text-align: right;
  }

  .sign-main-wrap {
    .sign-body {
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      overflow: hidden;
    }

    .sign-action {
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .el-radio-group {
        .el-radio-button .el-radio-button__inner {
          padding: 6px 10px;
        }
        .el-radio-button:first-child .el-radio-button__inner {
          border-radius: 30px 0 0 30px;
        }
        .el-radio-button:last-child .el-radio-button__inner {
          border-radius: 0 30px 30px 0;
        }
      }
    }
  }
}
</style>
